export enum ViewLevel {
  students = 'students',
  classes = 'classes',
  schools = 'schools',
  district = 'district',
}
